import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt-8 space-y-5" }
const _hoisted_4 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_5 = { class: "grid gap-3 lg:grid-cols-3" }
const _hoisted_6 = { class: "lg:col-span-2" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "grid gap-4 sm:grid-cols-2 xl:grid-cols-4" }
const _hoisted_9 = { class: "text-sm font-semibold text-slate-500" }
const _hoisted_10 = { class: "mt-3 text-2xl font-bold text-slate-900" }
const _hoisted_11 = { class: "mt-1 text-xs text-slate-500" }
const _hoisted_12 = { class: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" }
const _hoisted_13 = { class: "overflow-x-auto" }
const _hoisted_14 = { class: "min-w-full text-sm" }
const _hoisted_15 = { class: "bg-blue-900" }
const _hoisted_16 = { class: "px-4 py-3.5 text-left" }
const _hoisted_17 = { class: "px-4 py-3.5 text-left" }
const _hoisted_18 = { class: "px-4 py-3.5 text-left" }
const _hoisted_19 = { class: "px-4 py-3.5 text-left" }
const _hoisted_20 = { class: "bg-white divide-y divide-slate-100" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "px-4 py-3 align-middle" }
const _hoisted_24 = ["src", "onClick"]
const _hoisted_25 = {
  key: 1,
  class: "flex items-center justify-center w-10 h-10 text-xs font-medium text-slate-400 bg-slate-100 border border-slate-200 rounded-lg"
}
const _hoisted_26 = { class: "px-4 py-3 align-middle" }
const _hoisted_27 = { class: "font-semibold text-slate-900 whitespace-nowrap" }
const _hoisted_28 = { class: "px-4 py-3 align-middle" }
const _hoisted_29 = { class: "text-slate-700 whitespace-nowrap" }
const _hoisted_30 = { class: "px-4 py-3 align-middle" }
const _hoisted_31 = { class: "text-slate-700 whitespace-nowrap" }
const _hoisted_32 = { class: "px-4 py-3 align-middle max-w-md" }
const _hoisted_33 = ["title"]
const _hoisted_34 = { class: "px-4 py-3 align-middle" }
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_37 = { class: "px-4 py-3 text-slate-500 align-middle whitespace-nowrap" }
const _hoisted_38 = { class: "px-4 py-3 text-right align-middle whitespace-nowrap" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]

import { ref, computed, onMounted } from 'vue';
import { GET_KEMITRAAN, DELETE_KEMITRAAN } from "@/store/kemitraan.module";
import ModalForm from "../components/modal/FormKemitraan.vue";
import { useStore } from 'vuex';
import Breadcrumb from '../components/AppBreadcrumb.vue';
import Swal from 'sweetalert2';
import type { ApiErrorResponse, EntityId, Kemitraan } from '@/types/domain';
import SortButton from '@/components/table/SortButton.vue';

type SortDirection = 'asc' | 'desc';
type KemitraanSortKey = 'name' | 'picName' | 'picPhone' | 'createdAt';
type SortRule = {
  key: KemitraanSortKey;
  direction: SortDirection;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'KemitraanView',
  setup(__props) {

const store = useStore();

const isOpened = ref(false);
const dataUpdate = ref<Partial<Kemitraan>>({});
const currentId = ref<EntityId | undefined>(undefined);
const isImageModalOpen = ref(false);
const selectedImage = ref('');
const searchQuery = ref('');
const isLoading = ref(true);
const sortRules = ref<SortRule[]>([{ key: 'createdAt', direction: 'desc' }]);

const openModal = () => {
  dataUpdate.value = {};
  currentId.value = undefined;
  isOpened.value = true;
};

const handleModalClose = async () => {
  isOpened.value = false;
  dataUpdate.value = {};
  currentId.value = undefined;
  await getData();
};

const computedData = computed<Kemitraan[]>(() => {
  const list = store.getters.kemitraan;
  const items = Array.isArray(list) ? list : list?.data || [];
  return [...items].sort((a, b) => compareKemitraan(a, b, sortRules.value));
});

const kpiCards = computed(() => {
  const items = computedData.value;
  const withPic = items.filter((item) => item?.picName || item?.picPhone).length;
  const withMou = items.filter((item) => item?.mou).length;
  const withLogo = items.filter((item) => item?.image).length;

  return [
    {
      title: 'Total Mitra',
      value: String(items.length),
      description: 'Mitra yang tampil pada daftar',
    },
    {
      title: 'Kontak PIC',
      value: String(withPic),
      description: 'Mitra dengan kontak internal',
    },
    {
      title: 'Dokumen MoU',
      value: String(withMou),
      description: 'Mitra dengan dokumen kerja sama',
    },
    {
      title: 'Logo Mitra',
      value: String(withLogo),
      description: 'Mitra dengan logo terunggah',
    },
  ];
});

const getData = async () => {
  isLoading.value = true;
  try {
    await store.dispatch(GET_KEMITRAAN, {
      data: { limit: 50, search: searchQuery.value || undefined },
    });
  } finally {
    isLoading.value = false;
  }
};

let searchTimer: ReturnType<typeof setTimeout> | null = null;
const onSearch = () => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(getData, 350);
};

const normalizeText = (value: unknown) => String(value ?? '').toLowerCase();

const normalizeDate = (value: unknown) => {
  if (!value) return 0;
  const timestamp = new Date(String(value)).getTime();
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

const compareValue = (left: string | number, right: string | number) => {
  if (typeof left === 'number' && typeof right === 'number') return left - right;
  return String(left).localeCompare(String(right), 'id', { numeric: true, sensitivity: 'base' });
};

const compareKemitraan = (
  left: Kemitraan,
  right: Kemitraan,
  rules: SortRule[],
) => {
  const getValue = (item: Kemitraan, key: KemitraanSortKey) => {
    if (key === 'createdAt') return normalizeDate(item?.createdAt);
    return normalizeText(item?.[key]);
  };

  for (const rule of rules) {
    const result = compareValue(getValue(left, rule.key), getValue(right, rule.key));
    if (result !== 0) {
      return result * (rule.direction === 'asc' ? 1 : -1);
    }
  }

  return 0;
};

const defaultSortDirection = (key: KemitraanSortKey): SortDirection =>
  key === 'createdAt' ? 'desc' : 'asc';

const sortPriority = (key: KemitraanSortKey) => {
  const index = sortRules.value.findIndex((rule) => rule.key === key);
  return index === -1 ? 0 : index + 1;
};

const sortDirectionFor = (key: KemitraanSortKey): SortDirection => {
  return sortRules.value.find((rule) => rule.key === key)?.direction || defaultSortDirection(key);
};

const toggleSort = (key: KemitraanSortKey, event?: MouseEvent) => {
  const currentRule = sortRules.value.find((rule) => rule.key === key);
  const nextRule: SortRule = {
    key,
    direction: currentRule?.direction === 'asc' ? 'desc' : 'asc',
  };

  if (event?.shiftKey) {
    sortRules.value = currentRule
      ? sortRules.value.map((rule) => (rule.key === key ? nextRule : rule))
      : [...sortRules.value, { key, direction: defaultSortDirection(key) }];
    return;
  }

  sortRules.value = currentRule ? [nextRule] : [{ key, direction: defaultSortDirection(key) }];
};

onMounted(getData);

const openImageModal = (imageUrl: string) => {
  selectedImage.value = imageUrl;
  isImageModalOpen.value = true;
};
const closeImageModal = () => {
  isImageModalOpen.value = false;
};

const formatDate = (dateString?: string) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];
  return `${String(date.getDate()).padStart(2, '0')} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
};

const initials = (name?: string) => {
  if (!name) return '—';
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
};

const editItem = (item: Kemitraan) => {
  dataUpdate.value = { ...item };
  currentId.value = item.id;
  isOpened.value = true;
};

const deleteItem = async (id: EntityId) => {
  const result = await Swal.fire({
    title: 'Hapus kemitraan?',
    text: 'Data ini tidak bisa dikembalikan.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc2626',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Ya, hapus',
    cancelButtonText: 'Batal',
  });
  if (!result.isConfirmed) return;
  try {
    await store.dispatch(DELETE_KEMITRAAN, { id });
    await Swal.fire({
      title: 'Terhapus',
      text: 'Data kemitraan telah dihapus.',
      icon: 'success',
      confirmButtonColor: '#4f46e5',
    });
    await getData();
  } catch (err: unknown) {
    const apiError = err as ApiErrorResponse;
    Swal.fire({ icon: 'error', title: 'Gagal', text: apiError?.message || 'Gagal menghapus.' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: "kemitraan" }),
    (isOpened.value)
      ? (_openBlock(), _createBlock(ModalForm, {
          key: 0,
          id: currentId.value,
          title: `${currentId.value ? 'Edit' : 'Tambah'} Kemitraan`,
          data: dataUpdate.value,
          onClose: handleModalClose
        }, null, 8, ["id", "title", "data"]))
      : _createCommentVNode("", true),
    (isImageModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/60",
          onClick: closeImageModal
        }, [
          _createElementVNode("img", {
            src: selectedImage.value,
            alt: "Logo",
            class: "max-w-full max-h-full rounded-md shadow-lg"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
        _createElementVNode("div", { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }, [
          _cache[6] || (_cache[6] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-2xl font-bold md:text-4xl" }, "Kemitraan"),
            _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, "Kelola mitra institusi, kontak internal, deskripsi kerja sama, dan dokumen MoU.")
          ], -1)),
          _createElementVNode("button", {
            class: "inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#003793] shadow-lg transition-all hover:-translate-y-px hover:shadow-xl sm:w-auto",
            onClick: openModal
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              class: "h-4 w-4"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
                "clip-rule": "evenodd"
              })
            ], -1),
            _createTextVNode(" Tambah Kemitraan ", -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Cari", -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "absolute inset-y-0 left-0 flex items-center pl-2.5" }, [
                _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  class: "w-4 h-4 text-slate-400 fill-current"
                }, [
                  _createElementVNode("path", { d: "M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z" })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                onInput: onSearch,
                placeholder: "Cari nama mitra, PIC, atau nomor telepon...",
                class: "block w-full rounded-lg border border-slate-200 bg-white py-2 pl-8 pr-3 text-sm text-slate-700 placeholder-slate-400 transition-all focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
              }, null, 544), [
                [_vModelText, searchQuery.value]
              ])
            ])
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "rounded-xl bg-slate-50 px-4 py-3" }, [
            _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Kontak Internal"),
            _createElementVNode("p", { class: "mt-1 text-sm text-slate-600" }, "Nama dan telepon PIC dipakai untuk koordinasi admin.")
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiCards.value, (card) => {
          return (_openBlock(), _createElementBlock("div", {
            key: card.title,
            class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
          }, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(card.title), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(card.value), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(card.description), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex flex-col gap-3 border-b border-slate-100 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5" }, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Daftar Kemitraan"),
            _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Informasi mitra dan dokumen kerja sama yang dikelola admin.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("table", _hoisted_14, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_15, [
                _cache[12] || (_cache[12] = _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Logo", -1)),
                _createElementVNode("th", _hoisted_16, [
                  _createVNode(SortButton, {
                    label: "Nama Mitra",
                    active: sortPriority('name') > 0,
                    direction: sortDirectionFor('name'),
                    priority: sortPriority('name'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSort('name', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _createElementVNode("th", _hoisted_17, [
                  _createVNode(SortButton, {
                    label: "PIC",
                    active: sortPriority('picName') > 0,
                    direction: sortDirectionFor('picName'),
                    priority: sortPriority('picName'),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSort('picName', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _createElementVNode("th", _hoisted_18, [
                  _createVNode(SortButton, {
                    label: "Telepon PIC",
                    active: sortPriority('picPhone') > 0,
                    direction: sortDirectionFor('picPhone'),
                    priority: sortPriority('picPhone'),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleSort('picPhone', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Deskripsi", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "MoU", -1)),
                _createElementVNode("th", _hoisted_19, [
                  _createVNode(SortButton, {
                    label: "Dibuat",
                    active: sortPriority('createdAt') > 0,
                    direction: sortDirectionFor('createdAt'),
                    priority: sortPriority('createdAt'),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSort('createdAt', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-right text-blue-100" }, "Aksi", -1))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_20, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (c) => {
                      return _createElementVNode("td", {
                        key: c,
                        class: "px-4 py-3"
                      }, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("div", { class: "h-4 w-full max-w-[120px] animate-pulse rounded bg-slate-100" }, null, -1)
                      ]))])
                    }), 64))
                  ]))
                : (computedData.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("td", {
                        colspan: "8",
                        class: "px-5 py-12 text-sm text-center text-slate-400 italic"
                      }, "Belum ada data kemitraan.", -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(computedData.value, (k, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: k.id || index,
                        class: "transition-colors hover:bg-blue-50/40"
                      }, [
                        _createElementVNode("td", _hoisted_23, [
                          (k?.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: k.image,
                                alt: "logo",
                                class: "w-10 h-10 object-cover rounded-lg border border-slate-200 cursor-pointer shadow-sm hover:opacity-80",
                                onClick: ($event: any) => (openImageModal(k.image))
                              }, null, 8, _hoisted_24))
                            : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(initials(k?.name)), 1))
                        ]),
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("p", _hoisted_27, _toDisplayString(k?.name || '-'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("p", _hoisted_29, _toDisplayString(k?.picName || '-'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("p", _hoisted_31, _toDisplayString(k?.picPhone || '-'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("p", {
                            class: "text-slate-600 truncate",
                            title: k?.description || ''
                          }, _toDisplayString(k?.description || '-'), 9, _hoisted_33)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          (k?.mou)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: k.mou,
                                target: "_blank",
                                rel: "noopener",
                                class: "inline-flex items-center gap-1 text-sm font-semibold text-blue-600 hover:text-blue-800 hover:underline"
                              }, [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  class: "w-4 h-4",
                                  viewBox: "0 0 20 20",
                                  fill: "currentColor"
                                }, [
                                  _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
                                    "clip-rule": "evenodd"
                                  })
                                ], -1),
                                _createTextVNode(" Lihat ", -1)
                              ]))], 8, _hoisted_35))
                            : (_openBlock(), _createElementBlock("span", _hoisted_36, "—"))
                        ]),
                        _createElementVNode("td", _hoisted_37, _toDisplayString(formatDate(k?.createdAt)), 1),
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("button", {
                            class: "mr-2 rounded-lg bg-blue-50 px-2.5 py-1.5 text-sm font-semibold text-blue-700 hover:bg-blue-100",
                            onClick: ($event: any) => (editItem(k))
                          }, "Edit", 8, _hoisted_39),
                          _createElementVNode("button", {
                            class: "rounded-lg bg-red-50 px-2.5 py-1.5 text-xs font-semibold text-red-600 hover:bg-red-100",
                            onClick: ($event: any) => (deleteItem(k.id))
                          }, "Hapus", 8, _hoisted_40)
                        ])
                      ]))
                    }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})